import { render } from "./ProfileContactDetailsPage.vue?vue&type=template&id=3aa94af5&ts=true"
import script from "./ProfileContactDetailsPage.vue?vue&type=script&lang=ts"
export * from "./ProfileContactDetailsPage.vue?vue&type=script&lang=ts"

import "./ProfileContactDetailsPage.vue?vue&type=style&index=0&id=3aa94af5&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__